/**
 * "X wants to make you the Owner of Y" — shown under the header to the person
 * nominated in an ownership transfer (S2). Nothing changes until they accept;
 * accepting swaps the roles in one database step (lb_transfer_ownership).
 */

import { useState } from 'react'
import { orgApi, type PendingTransfer } from '@/lib/orgApi'
import { useOrgs } from '@/lib/useOrgs'
import { useNotifications } from '@/lib/notifications'
import { T } from './orgTheme'

export function TransferBanner({ t }: { t: PendingTransfer }) {
  const { reload } = useOrgs()
  const { toast } = useNotifications()
  const [busy, setBusy] = useState(false)

  const answer = async (accept: boolean) => {
    setBusy(true)
    try {
      await orgApi.respondTransfer(t.id, accept)
      toast({ status: 'success', title: accept ? `You’re now the Owner of ${t.orgName}` : 'Request declined' })
      await reload()
    } catch (e) {
      toast({ status: 'error', title: 'Couldn’t answer the request', body: (e as Error).message })
    } finally { setBusy(false) }
  }

  return (
    <div role="status" style={{ padding: '10px 16px', background: T.amberBg, color: '#7A4108', fontSize: 13.5, display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
      <span style={{ flex: '1 1 260px' }}><strong style={{ fontWeight: 600 }}>{t.fromName}</strong> wants to make you the Owner of <strong style={{ fontWeight: 600 }}>{t.orgName}</strong>. They’ll stay on as an Admin.</span>
      <button disabled={busy} onClick={() => answer(false)} style={{ padding: '6px 12px', borderRadius: 7, border: '1px solid #E9CFA5', background: '#fff', color: T.dark, fontSize: 13, cursor: 'pointer' }}>Decline</button>
      <button disabled={busy} onClick={() => answer(true)} style={{ padding: '6px 12px', borderRadius: 7, border: 'none', background: T.purple, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Accept</button>
    </div>
  )
}
